import React from 'react';
import {Avatar, Stack, SxProps, Typography} from '@mui/material';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import ProLogo from '@assets/ProLogo.png';
import {Chat} from '@services/Chat/types';
import {getRandomColor} from '../utils';

export type ContactOption = string | Chat;

interface ContactOptionItemProps {
    option: ContactOption;
    size?: number;
    sx?: SxProps;
}

export const ContactOptionItem: React.FC<ContactOptionItemProps> = ({option, size = 24, sx}) => {
    const label = typeof option === 'string' ? option : option.title;
    const type = typeof option === 'string' ? 'USER' : option.type;
    const bgColor = getRandomColor(label);

    let icon: React.ReactNode;
    if (type === 'GENA') {
        icon = (
            <img
                src={ProLogo}
                alt='ProLogo'
                style={{width: '100%', height: '100%'}}
            />
        );
    } else if (type === 'PRIVATE' || type === 'USER') {
        icon = <PersonOutlinedIcon />;
    } else {
        icon = <GroupsOutlinedIcon />;
    }

    return (
        <Stack
            direction='row'
            gap={1}
            alignItems='center'
            sx={{minWidth: 0, ...sx}}
        >
            <Avatar
                sx={{
                    width: size,
                    height: size,
                    backgroundColor: bgColor,
                    flexShrink: 0,
                }}
            >
                {icon}
            </Avatar>
            <Typography
                noWrap
                sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: 14,
                    fontWeight: 500,
                }}
            >
                {label}
            </Typography>
        </Stack>
    );
};
